export const styles = {
    width: '100%',
    height: '100%',
}

export const generateDefaultOptions = animationData => ({
    loop: true,
    autoplay: true,
    animationData,
    rendererSettings: {
        preserveAspectRatio: 'xMidYMid meet',
    },
})
